export var RecommendationModule;
(function (RecommendationModule) {
    RecommendationModule["DAILY_LIST"] = "DAILY_LIST";
    RecommendationModule["SPA_MODULE"] = "SPA_MODULE";
    RecommendationModule["RESTAURANT_MODULE"] = "RESTAURANT_MODULE";
})(RecommendationModule || (RecommendationModule = {}));
